import { ROUTES } from '../constants/routes';
import { QueryParams } from '../constants/QueryParams';

export const useLoginNavigation = (referralInfo: string) => {
  const returnedUrl = encodeURIComponent(
    `${window.location.href}&${QueryParams.RETURNED_FROM_LOGIN_PAGE}=true`,
  );
  return () => {
    window.location.assign(ROUTES.loginPage(returnedUrl, referralInfo));
  };
};
